import { styled, Typography } from "@mui/material"

import Breadcrumbs from "./Breadcrumbs/Breadcrumbs"

import packageJson from "../../../package.json"

const StyledFooter = styled("footer", {
})(({ theme }) => {
  return {
    display: "flex", flexDirection: "column",
    background: "white", boxShadow: theme.shadows[2],
    padding: theme.spacing(4, 4, 1)
  }
})

const Footer = (props) => {
  return (
    <StyledFooter id="footer">
      <Breadcrumbs />
      {props.children}
      <Typography
        variant="caption"
        color="textSecondary"
        sx={{
          textAlign: "end"
        }}
      >
        Version: {packageJson.version}
      </Typography>
    </StyledFooter>
  );
}

export default Footer